import axios from "axios";

import { PaymentSessionToken } from "redmond";
import { FulfillResponseV0, purchaseApi } from "@b2bportal/purchase-api";
import { ProductFunnelHeaderName, ProductFunnelHeader } from "./productFunnel";

const pollFinalized = (
  req: PaymentSessionToken,
  productFunnel: ProductFunnelHeader = ProductFunnelHeader.Hotels
): Promise<FulfillResponseV0> =>
  new Promise((resolve, reject) => {
    try {
      const res = purchaseApi(axios).apiV0PurchaseFulfillPollPost(
        {
          value: req.value,
        },
        { headers: { [ProductFunnelHeaderName]: productFunnel } }
      );

      res.then((body) => resolve(body.data)).catch((e) => reject(e));
    } catch (e) {
      reject(e);
    }
  });

export default pollFinalized;
